import { Navigate } from "react-router-dom";
import { isSuperAdmin } from "../utils/auth";

const SuperAdminRoute = ({ children }) => {
	if (!isSuperAdmin()) {
		return <Navigate to="/dashboard" replace />;
	}
	return children;
};

export default SuperAdminRoute;
